/** @jsx h */
import { h } from 'preact'

const VerifiedTick = () => (
  <svg xmlnsXlink='http://www.w3.org/1999/xlink' width={24} height={24}>
    <defs>
      <circle id='VerifiedTick-b' cx={7.995} cy={7.995} r={7.995} />
      <filter
        id='VerifiedTick-a'
        width='168.8%'
        height='168.8%'
        x='-34.4%'
        y='-34.4%'
        filterUnits='objectBoundingBox'
      >
        <feMorphology
          in='SourceAlpha'
          operator='dilate'
          radius={1}
          result='shadowSpreadOuter1'
        />
        <feOffset in='shadowSpreadOuter1' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation={1.5}
        />
        <feComposite
          in='shadowBlurOuter1'
          in2='SourceAlpha'
          operator='out'
          result='shadowBlurOuter1'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.229223279 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd' transform='translate(4 4)'>
      <use
        fill='#000'
        filter='url(#VerifiedTick-a)'
        xlinkHref='#VerifiedTick-b'
      />
      <use
        fill='#99B9AE'
        stroke='#FFF'
        strokeWidth={2}
        xlinkHref='#VerifiedTick-b'
      />
      <path
        fill='#FFF'
        d='M5.809 11.562L3.665 9.364a.578.578 0 0 1 .012-.82c.23-.223.6-.218.825.012l1.735 1.78 5.31-5.17a.585.585 0 0 1 .824.008.577.577 0 0 1-.009.82l-5.726 5.579a.585.585 0 0 1-.827-.01z'
      />
    </g>
  </svg>
)

export default VerifiedTick
